import API from '@/api';
import hasPermission from '../../utils/hasPermission';
import { groupPermissions } from '../../utils/licenseDetails';

const GET_DATA = 'GET_DATA';
const GET_DATA_FAILED = 'GET_DATA_FAILED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';

// Enabled the module to be namespaced
const namespaced = true;

function toCSV(json = {}, keys = []) {
  json = Object.values(json);
  let csv = '';
  csv += `${keys.join(',')}\n`;
  for (const line of json) {
    csv += `${keys
      .map((key) => {
        return Array.isArray(line[key]) ? line[key].join(` / `) : line[key];
        // return line[key];
      })
      .join(',')}\n`;
  }
  return csv;
}

function convertToCSV(arr) {
  const array = [Object.keys(arr[0])].concat(arr);
  return array
    .map((row) => {
      return Object.values(row)
        .map((value) => {
          return typeof value === 'string' ? JSON.stringify(value) : value;
        })
        .toString();
    })
    .join('\n');
}

const state = {
  loading: false,
  loadingData: false,
};

const getters = {
  loading: (state) => {
    return state.loading;
  },

  isLoading: (state) => {
    return state.loadingData;
  },
};

const actions = {
  // * Partner gets a specific partner based on user token
  async partner({ commit }) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.partners.partner();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getPartnerProducts a specific partner's product list
  async getPartnerProducts({ commit }) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.partners.partnerProducts();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * createPartnerProductKeys allows a partner to create product keys
  async createPartnerProductKeys({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.partners.createPartnerProductKeys(payload);

      if (Array.isArray(response?.data)) {
        const filteredData = response?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const hasMultipleSkus = filteredData?.[0]?.skucodes?.length > 1 ?? false;
        const keys = [
          'batchUUID',
          'createdByUserID',
          'partnerID',
          'productKey',
          hasMultipleSkus ? 'skucodes' : 'skucode',
          'type',
          'createdat',
        ];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getPartnerProductKeys a specific partner's product key list
  async getPartnerProductKeys({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.partners.partnerProductKeys(payload);

      if (Array.isArray(response?.data?.data)) {
        const filteredData = response?.data?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const keys = [
          'batchUUID',
          'createdByUserID',
          'partnerID',
          'productKey',
          'skucodes',
          'userID',
          'type',
          'desktopLicenseID',
          'mobileLicenseID',
          'createdat',
          'updatedat',
        ];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getPartnerKeyReport a specific partner's product list
  async getPartnerKeyReport({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await API.partners.partnerKeyReport(payload);

      if (Array.isArray(response?.data)) {
        const filteredData = response?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const keys = ['partner_id', 'skucode', 'webtitle', 'total'];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

// @ MUTATIONS ====================================================================
const mutations = {
  [GET_DATA](state) {
    state.loadingData = true;
  },

  [GET_DATA_FAILED](state) {
    state.loadingData = false;
  },

  [GET_DATA_SUCCESS](state, data) {
    state.loadingData = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
